import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Form, Button} from 'react-bootstrap';
import {Formik, ErrorMessage, Form as FormikForm} from 'formik';
import * as yup from 'yup';

const ForgotPassword = props => {
	return (
		<Fragment>
			<p>Enter your email address and we'll send you a link to reset your password.</p>
			<Formik
				initialValues={{email: ''}}
				onSubmit={props.onSubmit}
				enableReinitialize={true}
				validationSchema={yup.object().shape({
					email: yup
						.string()
						.email('Please enter a valid email address.')
						.required('Please enter your email')
				})}
			>
				{({handleChange, handleBlur, isSubmitting, values, errors, touched, isValid}) => (
					<FormikForm>
						<Form.Group className={touched.email && errors.email ? 'has-danger' : ''}>
							<Form.Control
								name="email"
								value={values.email}
								placeholder="Email"
								onChange={handleChange}
								onBlur={handleBlur}
								className={touched.email && errors.email ? 'is-invalid' : ''}
							/>
							<ErrorMessage component="div" className="invalid-feedback" name="email" />
						</Form.Group>
						{props.error && <div className="text-danger">{props.error}</div>}
						{props.data && <p className="text-success">A reset password link has been sent to your email address.</p>}
						<Button disabled={isSubmitting || props.data} type="submit">
							{isSubmitting ? 'Sending...' : props.data ? 'Email Sent' : 'Reset Password'}
						</Button>
						<Button variant="link" onClick={props.onClickLogin}>
							Log In
						</Button>
					</FormikForm>
				)}
			</Formik>
		</Fragment>
	);
};

ForgotPassword.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onClickLogin: PropTypes.func.isRequired
};

export default ForgotPassword;
